import { z } from 'zod';

import type { TranslateFn } from '@/shared/types';

export function stringMax(t: TranslateFn, max: number): z.ZodString {
    return z.string().max(max, t('validation.string.max', { count: max }));
}
